import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

// 分组
export function tagGroupList(data) { return axios.post(`${base.url}/business/tagManagement/group/list`, qs.stringify(data)) }
export function tagGroupAll() { return axios.post(`${base.url}/business/tagManagement/group/all`) }
export function tagGroupSave(data) { return axios.post(`${base.url}/business/tagManagement/group/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }

// 标签
export function tagList(groupId) { return axios.post(`${base.url}/business/tagManagement/list`, groupId != null ? qs.stringify({ groupId }) : undefined) }
export function tagListAll() { return axios.post(`${base.url}/business/tagManagement/list`) }
export function tagSave(data) { return axios.post(`${base.url}/business/tagManagement/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }
export function tagDelete(ids) { return axios.post(`${base.url}/business/tagManagement/delete`, qs.stringify({ ids })) }

// 规则
export function tagRuleList(data) { return axios.post(`${base.url}/business/tagManagement/rule/list`, qs.stringify(data)) }
export function tagRuleSave(data) { return axios.post(`${base.url}/business/tagManagement/rule/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }
export function tagRuleDelete(ids) { return axios.post(`${base.url}/business/tagManagement/rule/delete`, qs.stringify({ ids })) }
export function tagRuleToggleStatus(id) { return axios.post(`${base.url}/business/tagManagement/rule/toggleStatus`, qs.stringify({ id })) }

// 事件日志
export function tagEventLogList(data) { return axios.post(`${base.url}/business/tagManagement/eventLog/list`, qs.stringify(data)) }

// 标签关联客户
export function tagTaggedCustomers(data) { return axios.post(`${base.url}/business/tagManagement/taggedCustomers`, qs.stringify(data)) }
